import React from 'react';

import HousingConnectorContent from './HousingConnectorContent';
import HousingConnectorFieldSet from './HousingConnectorFieldSet';

const propTypes = {};
const defaultProps = {};

const HousingConnectorContentWithFields = () => (
  <div data-testid="HousingConnectorContentWithFields">
    <HousingConnectorContent />

    <HousingConnectorFieldSet />
  </div>
);

HousingConnectorContentWithFields.propTypes = propTypes;
HousingConnectorContentWithFields.defaultProps = defaultProps;

export default HousingConnectorContentWithFields;
